import { render, staticRenderFns } from "./BindErpBox.vue?vue&type=template&id=7b852836&scoped=true"
import script from "./BindErpBox.vue?vue&type=script&lang=js"
export * from "./BindErpBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b852836",
  null
  
)

export default component.exports